import React from 'react';
import { Modal, ModalProps } from '@common-fe/common-fe';

import useAutoBlockedModal from './hooks/useAutoBlockedModal';
interface Props extends ModalProps {
  isFullScreen?: boolean;
  contentMobileStyle?: React.CSSProperties;
}
const AutoBlockedModal: React.FC<Props> = ({ isFullScreen, ...props }) => {
  const { isClosingByClickOutsideBlocked } = useAutoBlockedModal({ visible: props?.visible });

  return (
    <Modal
      {...(isFullScreen
        ? {
            wrapperStyle: { padding: '0px', ...props?.wrapperStyle },
            contentStyle: {
              marginLeft: '0px',
              marginRight: '0px',
              borderRadius: '0px',
              minHeight: '100vh',
              ...props?.contentMobileStyle,
            },
          }
        : {})}
      {...props}
      isClosingByClickOutsideBlocked={isClosingByClickOutsideBlocked || props?.isClosingByClickOutsideBlocked}
    />
  );
};

export default AutoBlockedModal;
